import { createContext, useContext, useState } from 'react';
import { useTheme } from '../../hooks/useTheme';

// ── Design token maps ─────────────────────────────────────────────
const DARK_VARS = {
  '--d-bg':           '#080a10',
  '--d-bg-dim':       '#0c0d14',
  '--d-nav':          '#0e0f16',
  '--d-surface':      '#111318',
  '--d-surface-2':    '#15161d',
  '--d-code-bg':      '#1a1b24',
  '--d-editor-bar':   '#1e1f2a',
  '--d-border':       'rgba(255,255,255,0.07)',
  '--d-border-sub':   'rgba(255,255,255,0.05)',
  '--d-border-str':   'rgba(255,255,255,0.12)',
  '--d-text-hi':      'rgba(255,255,255,0.92)',
  '--d-text-1':       'rgba(255,255,255,0.7)',
  '--d-text-2':       'rgba(255,255,255,0.45)',
  '--d-text-3':       'rgba(255,255,255,0.25)',
  '--d-hover':        'rgba(255,255,255,0.04)',
  '--d-subtle':       'rgba(255,255,255,0.03)',
  '--d-accent-fg':    '#a78bfa',
  '--d-code-text':    '#c4b5fd',
  '--d-grid-stroke':  'rgba(255,255,255,0.04)',
  '--d-axis-tick':    'rgba(255,255,255,0.3)',
  '--d-scrollbar':    'rgba(255,255,255,0.08)',
};

const LIGHT_VARS = {
  '--d-bg':           '#f5f2ff',
  '--d-bg-dim':       '#ede8ff',
  '--d-nav':          '#ffffff',
  '--d-surface':      '#ffffff',
  '--d-surface-2':    '#f0ecff',
  '--d-code-bg':      '#f8f6ff',
  '--d-editor-bar':   '#eeeaff',
  '--d-border':       'rgba(139,92,246,0.12)',
  '--d-border-sub':   'rgba(139,92,246,0.07)',
  '--d-border-str':   'rgba(139,92,246,0.28)',
  '--d-text-hi':      '#111827',
  '--d-text-1':       '#374151',
  '--d-text-2':       '#6B7280',
  '--d-text-3':       '#9CA3AF',
  '--d-hover':        'rgba(139,92,246,0.05)',
  '--d-subtle':       'rgba(139,92,246,0.03)',
  '--d-accent-fg':    '#6d28d9',
  '--d-code-text':    '#5b21b6',
  '--d-grid-stroke':  'rgba(139,92,246,0.08)',
  '--d-axis-tick':    '#9CA3AF',
  '--d-scrollbar':    'rgba(139,92,246,0.1)',
};

// ── Context ──────────────────────────────────────────────────────
export const DemoThemeCtx = createContext({ isDark: true, toggle: () => {} });

export const useDemoTheme = () => useContext(DemoThemeCtx);

// ── Provider ─────────────────────────────────────────────────────
export function DemoThemeProvider({ children }) {
  const { theme } = useTheme();
  // Default: dark (enterprise feel). User can toggle within the demo.
  const [isDark, setIsDark] = useState(true);

  const vars = isDark ? DARK_VARS : LIGHT_VARS;

  return (
    <DemoThemeCtx.Provider value={{ isDark, toggle: () => setIsDark((d) => !d) }}>
      {/* This div injects all CSS custom properties that cascade to all children,
          including position:fixed descendants. */}
      <div style={vars} className="contents">
        {children}
      </div>
    </DemoThemeCtx.Provider>
  );
}
